import React, { FunctionComponent } from "react";
import { useNavigate } from "react-router";

import Typography from "@mui/material/Typography";
import ListItemButton from "@mui/material/ListItemButton";
import CircularProgress from "@mui/material/CircularProgress";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

export interface MenuItemI {
  route: string;
  icon: FunctionComponent;
  name: string;
  loading?: boolean;
  onClick?: () => Promise<void>;
}

interface UserMenuItemProps {
  item: MenuItemI;
}

const UserMenuItem: React.FC<UserMenuItemProps> = React.memo(
  function UserMenuItem({ item }) {
    const navigate = useNavigate();

    const { route, icon: Icon, name, loading, onClick } = item;

    const onItemClick = async () => {
      onClick && (await onClick());
      analytics().sendEvent(`${AnalyticsEvents.user_menu_}${route}`);
      navigate(route);
    };

    return (
      <ListItemButton
        sx={{ m: 0, color: "#393939", alignItems: "left" }}
        onClick={onItemClick}
        disabled={loading}
      >
        {loading ? <CircularProgress size={24} /> : <Icon />}
        <Typography variant="body2" sx={{ ml: 1.5 }} color="text.secondary">
          {name}
        </Typography>
      </ListItemButton>
    );
  }
);

export default UserMenuItem;
